import { put, takeLatest, call } from "redux-saga/effects";
import CatalogoActions, {
    Types as CatalogoTypes,
} from "../../stores/catalogo/Actions";
import CatalogoService from "../../services/catalogo/CatalogoService";
import { removeLineBreaks } from "../../utils/StringUtil";

function* getZonas(request) {
    yield put(CatalogoActions.getZonasLoading());

    const zonasResponse = yield call(CatalogoService.getZonas, request.payload);

    const zonas = zonasResponse?.distribucionPolitica?.map(zona => {
        return {
            id: zona.codigoDistribucion,
            key: zona.codigoDistribucion,
            label: zona.distribucionPolitica,
            value: zona.distribucionPoliticaId,
        }
    })

    yield put(CatalogoActions.getZonasSuccess({ zonas }));
}

function* getProvincias(request) {
    yield put(CatalogoActions.getProvinciasLoading());

    const provinciasResponse = yield call(CatalogoService.getProvincias, request.payload);

    const provincias = provinciasResponse?.distribucionPolitica?.map(provincia => {
        return {
            id: provincia.distribucionPoliticaId,
            key: provincia.codigoDistribucion,
            label: provincia.distribucionPolitica,
            value: provincia.codigoDistribucion,
        }
    })

    yield put(CatalogoActions.getProvinciasSuccess({ provincias }));
}

function* getDiagnosticos(request) {
    yield put(CatalogoActions.getDiagnosticosLoading());

    const diagnosticosResponse = yield call(
        CatalogoService.getDiagnosticos,
        request.payload
    );

    const diagnosticos = diagnosticosResponse?.listadoDiagnosticos?.map(diagnostico => {
        return {
            ...diagnostico,
            key: diagnostico.codigo,
            descripcion: removeLineBreaks(diagnostico.descripcion || "Sin descripción")
        }
    })

    yield put(CatalogoActions.getDiagnosticosSuccess({ diagnosticos }));
}

const exportedArray = [
    takeLatest(CatalogoTypes.GET_ZONAS, getZonas),
    takeLatest(CatalogoTypes.GET_PROVINCIAS, getProvincias),
    takeLatest(CatalogoTypes.GET_DIAGNOSTICOS, getDiagnosticos),
];

export default exportedArray;